<template>
  <div class="table-responsive hide-scroll" ref="formContainer" style="position:relative; border-top:1px solid #48a6a6;  margin-top: 0px; border-left:1px solid #dfdfdf; border-right:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; border-bottom-right-radius: 10px; border-bottom-left-radius: 10px; border-radius:unset;overflow: visible;">
    <!-- <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <div class="form-group">
            <label>Update Organizations Status:</label>
            <select @change="organizationStatusSet($event)" v-model="user_status_to_set" class="form-control"
              style="padding: 5px 10px" placeholder="Select list">
              <option selected="selected" value=""></option>
              <option value="1">Active Organizations</option>
              <option value="2">Trial Organizations</option>
              <option value="3">Inactive Organizations</option>
              <option value="4">Blocked Organizations</option>
            </select>
          </div>
        </div>
      </div>
    </div> -->

    

    <!-- <div class="form-group" style="float: right; margin-left: 10px">
      <input type="button" class="btn btn-default" style="color: #fff; background-color: #007bff; border-radius: 6px"
        value="Bulk Reset Password" data-toggle="modal" @click="sendBulkEmail($event)" />
      <span class="checkmark"></span>
    </div>
    <div class="modal fade" id="emailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" style="color: black">
            <h5 class="modal-title">Select to send password reset request</h5>
          </div>
          <div class="modal-body" style="height: 400px; max-height: 400px">
            <table class="
                table   table-hover
                text-center
              " id="dataTable">
              <thead>
                <tr>
                  <th>Expand</th>
                  <th>Select</th>
                  <th>Company</th>
                  <th>Role</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(info, key) in infos">
                  <tr style="background-color: #cae0f7">
                    <td width="8%">
                      <button @click="toggle(key)" :class="{ opened: opened.includes(key) }"
                        style="border-radius: 3px; border: none">
                        <i class="fas fa-caret-right" aria-hidden="true" v-if="!opened.includes(key)"></i>
                        <i class="fas fa-caret-down" aria-hidden="true" v-else-if="opened.includes(key)"></i>
                      </button>
                    </td>
                    <td width="8%">
                      <input type="checkbox" @click="checkedMails(key, $event)" :value="key"
                        :id="key.split(' ').join('_')" :disabled="!opened.includes(key)" />
                    </td>
                    <td style="text-align: left">{{ key }}</td>
                    <td style="text-align: left"></td>
                    <td style="text-align: left"></td>
                    <th style="text-align: left"></th>
                  </tr>
                  <template v-if="opened.includes(key)" v-for="(data, Childkey) in info">
                    <tr :key="Childkey" style="color: #1977da; background-color: white">
                      <td></td>
                      <td>
                        <input type="checkbox" @click="
                            checkedChildMails(key, Childkey, data, $event),
                              parentRemoveDisable(key)
                          " :value="data.email" :id="data.email" v-model="data.ischecked" style="margin-left: 30px" />
                      </td>
                      <td style="text-align: left">{{ data.user_name }}</td>
                      <td v-if="data.role_id === '0'">Admin</td>
                      <td v-else-if="data.role_id === '3'">Manager</td>
                      <td v-else-if="data.role_id === '6'">Driver</td>
                      <td v-else-if="data.role_id === '4'">
                        Shipping and Receiving
                      </td>
                      <td v-else-if="data.role_id === '9'">
                        Production Supervisor
                      </td>
                      <td v-else></td>
                      <th style="text-align: left">{{ data.email }}</th>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
            <button type="button" @click="sendResetRequest" class="btn btn-primary">
              Send
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div>
		<button type="button" @click="createOrg" class="btn btn-primary">Add New ORG</button>
		</div> -->
    <!-- <div class="form-group" style="float: right; margin-left: 10px">
      <download-excel class="btn btn-sm btn-outline-light color-default mr-3" style="
          color: #48a6a6 !important;
          border: 1px solid #48a6a6;
          padding: 8px 13px;
          margin-right: 6px;
          cursor: pointer;
        " :data="excelDownloadData" :fields="json_fields">
        Excel Download
      </download-excel>
    </div> -->
    <!-- <div class="form-group" style="float: right; margin-bottom: 10px" ref="formContainer">
      <input class="form-control" type="text" v-model="search" placeholder="Search organizations.."
        @keyup="organizationSearch" />
    </div> -->
    <!-- -->

    <table class="table table-responsive table-striped table-light table-bordered table-hover text-center d-block" id="dataTable" width="100%" cellspacing="0" ref="formContainer">
      <thead >
        <tr>
          <th style="width: 5%">
            <input type="checkbox" value="1" v-on:change="changeAllChecboxes" id="user_parent_row" name="" />
          </th>
          <th style="width: 20%">Company Name</th>
          <th style="width: 10%">Username</th>
          <th style="width: 15%">Email</th>
          <th style="width: 10%">Phone</th>
          <th style="width: 10%">Country</th>
          <th style="width: 10%">State</th>
          <th style="width: 10%">City</th>
          <th style="width: 10%">Created</th>
          <th style="width: 20%">Status</th>
          <th style="width: 10%">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr  v-if="isLoader" style="background-color:#fbfcfc" >
          <td colspan="16">
            <b-skeleton-wrapper >
                <b-skeleton height="40px" ></b-skeleton>   
                <b-skeleton height="40px"></b-skeleton>  
                <b-skeleton height="40px"></b-skeleton>                                     
            </b-skeleton-wrapper> 
          </td>
        </tr>
        <organization-row  v-show="!isLoader" v-for="organization in organizations" :organization="organization" :page="currentPage" :tab="status"
          :search="search" :key="organization.id"></organization-row>
      </tbody>
    </table>
    <h5 style="text-align: center" class="pt-2" v-if="organizations.length < 1 && !isLoader">
      No Organization found.
    </h5>
   
      <div  v-if="!isLoader" style="background: white;
    border-top: 1px solid #dfdfdf; display: flex;
    justify-content: end;">
    <!-- <span style="color:#48a6a6;     padding: 14px 14px 0px 0px;">Total Organizations: <b>{{totalOrganizations}}</b></span> -->
    <span class="display-rows" style="color:#48a6a6;     padding: 14px 14px 0px 0px;">Display Rows: <b>{{totalRows}}</b></span>
            <paginate style="    padding: 12px 12px 0px 0px;" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''"
            :first-button-text="''" :last-button-text="''" :first-last-button="true"
            :container-class="'pagination pagination-sm'" :page-class="'page-item'" :prev-class="'page-item prev'"
            :next-class="'page-item next'" :page-link-class="'page-link'" :prev-link-class="'page-link'"
            :next-link-class="'page-link'"></paginate>
            
      </div>
    </div>
</template>

<script>

  import OrganizationRow from "./organization_row";
  import OrgForm from "./create_org_form.vue";
  import BulkEmail from "./BulkEmail";

  import Vue from "vue";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import axios from "axios";
  import $ from "jquery";
  Vue.use(Loading);

  export default {
    components: {
      OrganizationRow,
      BulkEmail,
    },

    data: function () {
      return {
        isLoader:true,
        fullPage: true,
        search: "",
        user_status: "all",
        user_status_to_set: "",
        checkAll: true,
        infos: null,
        users_data: [],
        opened: [],
        information: [],
        selectedEmails: {},
        selected: [],
        allSelected: false,
        json_fields: {
          "Company name": "legal_name",
          "User name": "user_name",
          Email: "email",
          Phone: "phone",
          "Created At": "created_at",
          Status: "status",
        },
      };
    },

    props: ["organizations", "excelDownloadData", "totalPages", "totalRows", "page", "status","skeletonLoader","search"],

    computed: {
      currentPage: {
        get: function () {
          
          return this.page;
        },
        set: function () { },
      },
      filteredList() {
        return this.organizations.filter((organization) => {
          return organization.user_name
            .toLowerCase()
            .includes(this.search.toLowerCase());
        });
      },
      showskLoader:function(){
        this.isLoader = this.skeletonLoader;
        return this.skeletonLoader;
      }
    },
     watch:{
      showskLoader: function () {
          this.isLoader = this.skeletonLoader;
          return this.skeletonLoader;
      }
     } ,
    methods: {
      parentRemoveDisable(index) {
        let id = index.split(" ").join("_");
        var size = this.selectedEmails[index].filter(function (value) {
          return value !== undefined;
        }).length;

        if (this.infos[index].length == size) {
          $("#" + id).prop("checked", true);
          $("#" + id)
            .parent()
            .removeClass("parenCheckDisable");
        }
      },
      checkedMails(index, e) {
        let seletedOrg = this.infos[index];
        if (e.target.checked) {
          $.each(seletedOrg, function (k, val) {
            val["ischecked"] = true;
          });
          this.selectedEmails[index] = _.cloneDeep(seletedOrg);
        } else {
          $.each(seletedOrg, function (k, val) {
            val["ischecked"] = false;
          });
          delete this.selectedEmails[index];
        }

        let id = index.split(" ").join("_");
        $("#" + id)
          .parent()
          .removeClass("parenCheckDisable");
      },

      checkedChildMails(ParentIndex, ChildIndex, value, e) {
        let id = ParentIndex.split(" ").join("_");

        if (this.selectedEmails[ParentIndex]) {
          $("#" + id)
            .parent()
            .addClass("parenCheckDisable");

          if (e.target.checked) {
            this.selectedEmails[ParentIndex][ChildIndex] = value;
          } else {
            $("#" + id).prop("checked", false);
            delete this.selectedEmails[ParentIndex][ChildIndex];

            var size = this.selectedEmails[ParentIndex].filter(function (value) {
              return value !== undefined;
            }).length;
            if (size == 0) {
              $("#" + id)
                .parent()
                .removeClass("parenCheckDisable");
            }
          }
        } else {
          let new_data = [];
          for (var i = 0; i < this.infos[ParentIndex].length; i++) {
            if (i == ChildIndex) {
              new_data.push(value);
            } else {
              let data = undefined;
              new_data.push(data);
            }
          }
          this.selectedEmails[ParentIndex] = new_data;
          $("#" + id)
            .parent()
            .addClass("parenCheckDisable");
        }
      },
      toggle(id) {
        const index = this.opened.indexOf(id);
        if (index > -1) {
          this.opened.splice(index, 1);
        } else {
          this.opened.push(id);
        }
      },
      setPage(page) {
        this.$emit("setPage", page);
      },
      organizationSearch() {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.isLoader = true;
        let self = this;
        this.$store
          .dispatch("users/getAllOraganizations", [
            self.page,
            self.search,
            self.status,
          ])
          .then(() => {
            // loader.hide();
            this.isLoader = false;
          });
      },
      changeAllChecboxes(event) {
        let self = this;
        self.checkAll = !self.checkAll;
        let children = this.$el.querySelectorAll(".user_row");
        for (var i = 0; i < children.length; i++) {
          children[i].checked = !self.checkAll;
        }
      },

      sendResetRequest(event) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.isLoader = true;
        let self = this;
        let user_data = this.selectedEmails;
        if ($.isEmptyObject(user_data)) {
          alert("Please check any Organizations first.");
          // loader.hide();
          this.isLoader = false;
          return;
        }

        if (!$.isEmptyObject(this.selectedEmails)) {
          $.each(this.selectedEmails, function (k, values) {
            $.each(values, function (k, val) {
              if (val !== undefined) {
                self.users_data.push(val);
              }
            });
          });
        }
        axios
          .post("admin/bulk-password-reset", {
            data: self.users_data,
          })
          .then((res) => {
            // $('#emailModal').hide();
            self.users_data = [];
            // loader.hide(); 
            this.isLoader = false;
            this.$toast.success(res.data.message);
          })
          .catch(() => {
            // loader.hide();
            this.isLoader = false;
          });
      },

      sendBulkEmail(event) {
        $("#emailModal").modal();
      },

      formateData(values) {
        let res = _.cloneDeep(values);
        let org_data = {};

        for (var i = 0; i < res.length; ++i) {
          var obj = res[i];
          obj["ischecked"] = false;

          if (org_data[obj.organization_name] === undefined)
            org_data[obj.organization_name] = [];

          if (obj.email != null) org_data[obj.organization_name].push(obj);
        }

        return org_data;
      },
      getUsers() {
        // let loader = this.$loading.show({
        //   loader: "dots",
        // });
        this.isLoader = true;
        var limit = 0;
        axios.get("/admin/users?limit=" + limit).then((response) => {
          let res = response.data.data;
          let data = this.formateData(res);
          this.infos = data;
          // loader.hide();
          this.isLoader = false;
        });
      },
      createOrg() {
        this.$store.dispatch("modal/createOrg", {
          action: "create",
          title: "Create Organization",
          component: OrgForm,
        });
      },

      organizationStatusSet(event) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.isLoader = true;
        let self = this;
        let children = this.$el.querySelectorAll(".user_row:checked");
        let status_selected = event.target.value;
        let org_ids = [];

        if (children.length > 0) {
          for (var i = 0; i < children.length; i++) {
            org_ids.push(children[i].dataset.id);
          }
        
          this.$store
            .dispatch("users/setOrganizationsStatus", [status_selected, org_ids,''])
            .then( () => {
              this.isLoader = false;
            });
        } else {
          alert("Please check any Organizations first.");
          // loader.hide();
          this.isLoader = false;
        }
      },
    },
    mounted() {
      this.getUsers();
    },
  };
</script>
<style scoped>
  #dataTable.table-responsive:has(.dropdown-menu.show) {
    overflow: visible;
  }

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
  }

  .parenCheckDisable>input {
    height: 16px;
    width: 16px;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border: 1px solid gray;
    border-radius: 2px;
    outline: none;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    background-color: gray;
    cursor: pointer;
    position: relative;
    top: 3px;
  }

  .parenCheckDisable>input::before {
    content: "\f068";
    /* display: block; */
    text-align: center;
    color: #fff;
    position: relative;
    left: 0.2rem;
    top: -0.2rem;
    font-family: FontAwesome;
    font-size: 10px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.8s cubic-bezier(0.3, 0.5, 0.8, 1);
  }

  .fade-enter,
  .fade-leave-to {
    transform: translateX(15px);
    opacity: 0;
  }
  
</style>